export const InfoMarkModal = () => (
  <svg width="1em" height="1em" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_3753_461639)">
      <g clipPath="url(#clip0_3753_461639)">
        <path
          d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5H32C36.4183 0.5 40 4.08172 40 8.5V32.5C40 36.9183 36.4183 40.5 32 40.5H8C3.58172 40.5 0 36.9183 0 32.5V8.5Z"
          fill="#DF7009"
        />
        <g filter="url(#filter1_dd_3753_461639)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9679 13C15.5286 13 15.1496 13 14.8375 13.0255C14.508 13.0524 14.1803 13.1118 13.865 13.2725C13.3946 13.5122 13.0122 13.8946 12.7725 14.365C12.6118 14.6803 12.5524 15.008 12.5255 15.3375C12.5 15.6496 12.5 16.0286 12.5 16.4679V24.5321C12.5 24.9714 12.5 25.3504 12.5255 25.6625C12.5524 25.992 12.6118 26.3197 12.7725 26.635C13.0122 27.1054 13.3946 27.4878 13.865 27.7275C14.1803 27.8882 14.508 27.9476 14.8375 27.9745C15.1496 28 15.5286 28 15.9679 28H24.0321C24.4714 28 24.8504 28 25.1625 27.9745C25.492 27.9476 25.8197 27.8882 26.135 27.7275C26.6054 27.4878 26.9878 27.1054 27.2275 26.635C27.3882 26.3197 27.4476 25.992 27.4745 25.6625C27.5 25.3504 27.5 24.9714 27.5 24.5321V16.4679C27.5 16.0286 27.5 15.6496 27.4745 15.3375C27.4476 15.008 27.3882 14.6803 27.2275 14.365C26.9878 13.8946 26.6054 13.5122 26.135 13.2725C25.8197 13.1118 25.492 13.0524 25.1625 13.0255C24.8504 13 24.4714 13 24.0322 13H15.9679ZM18.3333 19.6667C18.3333 19.2064 18.7064 18.8333 19.1667 18.8333H20C20.4602 18.8333 20.8333 19.2064 20.8333 19.6667V23.8333C20.8333 24.2936 20.4602 24.6667 20 24.6667C19.5398 24.6667 19.1667 24.2936 19.1667 23.8333V20.5C18.7064 20.5 18.3333 20.1269 18.3333 19.6667ZM20 16.3333C19.5398 16.3333 19.1667 16.7064 19.1667 17.1667C19.1667 17.6269 19.5398 18 20 18C20.4602 18 20.8333 17.6269 20.8333 17.1667C20.8333 16.7064 20.4602 16.3333 20 16.3333Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_3753_461639"
        x="0"
        y="0.5"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.33333" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.6 0 0 0 0 0.343059 0 0 0 0 0.105882 0 0 0 0.55 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3753_461639" />
      </filter>
      <filter
        id="filter1_dd_3753_461639"
        x="-6"
        y="2.5"
        width="52"
        height="52"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3753_461639" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3753_461639"
          result="effect2_dropShadow_3753_461639"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_3753_461639"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_3753_461639">
        <path
          d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5H32C36.4183 0.5 40 4.08172 40 8.5V32.5C40 36.9183 36.4183 40.5 32 40.5H8C3.58172 40.5 0 36.9183 0 32.5V8.5Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)

export default InfoMarkModal
